import React, { Component } from 'react';

import QuestionRadio from './QuestionRadio';
import QuestionLongAnswer from './QuestionLongAnswer';
import QuestionShortAnswer from './QuestionShortAnswer';

class QuestionMultipart extends Component {
  handleAnswerChange = (parts) => {
    const { saveAnswer, currentQuestion } = this.props;
    saveAnswer({
      id: currentQuestion.id,
      index: currentQuestion.index,
      answer: { parts },
    });
  }

  renderInput({ id, label, questionType, parts = {} }, i) {
    switch (questionType) {
      case 'long_answer':
        return (
          <QuestionLongAnswer
            questionId={id}
            label={label}
            value={this.answers[id] || ''}
            onChange={e => this.handleAnswerChange({ [id]: e.target.value })}
            autoFocus={i === 0}
          />
        );
      case 'short_answer':
        return (
          <QuestionShortAnswer
            questionId={id}
            label={label}
            value={this.answers[id] || ''}
            onChange={e => this.handleAnswerChange({ [id]: e.target.value })}
            autoFocus={i === 0}
          />
        );
      case 'radio':
        return (
          <QuestionRadio
            answer={this.answers[id] || { parts: {} }}
            onChange={parts => this.handleAnswerChange({ [id]: { parts } })}
            parts={parts}
            autoFocus={i === 0}
          />
        );
      default:
        return null;
    }
  }

  render() {
    const { currentAnswers, currentQuestion } = this.props;
    this.answers = currentAnswers.parts ? currentAnswers.parts : {};
    return currentQuestion.parts.map((part, i) => (
      <div
        key={part.id}
        className={`new-assessment-detail__part${part.layout === 'half-width' ? ' new-assessment-detail__part--half-width' : ''}`}
      >
        {part.content && (
          <p className="new-assessment-detail__part-content">
            {part.content}
          </p>
        )}
        {this.renderInput(part, i)}
      </div>
    ));
  }
}

export default QuestionMultipart;



// WEBPACK FOOTER //
// ./src/components/features/assessment/QuestionMultipart.js